import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    date: '',
    message: '',
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic client-side validation
    if (!form.name || !form.email || !form.phone || !form.eventType || !form.date) {
      setStatus({ type: 'error', message: 'Please fill in all required fields.' });
      return;
    }

    // In a real app you'd POST this to an API or send an email. For now we log and show a friendly message.
    // Keep this lightweight and safe (no external network calls here).
    // eslint-disable-next-line no-console
    console.log('Booking request:', form);
    setStatus({ type: 'success', message: 'Booking request sent — we will contact you shortly.' });

    // Clear form after submit
    setForm({ name: '', email: '', phone: '', eventType: '', date: '', message: '' });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2>Get in Touch</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Contact Details</h3>
            <div className="contact-item">
              <strong>Address:</strong>
              <p>Devakottai, Tamil Nadu, India</p>
            </div>
            <div className="contact-item">
              <strong>Phone:</strong>
              <p>+91 9942038191 </p>

            </div>
            <div className="contact-item">
              <strong>WhatsApp:</strong>
              <p>+91 8778030302</p>
            </div>
            <div className="contact-item">
              <strong>Email:</strong>
              <p>lathadigitaldvk@gmail.com</p>
            </div>
          </div>
          <div className="contact-form">
            <h3>Book Your </h3>
            <form onSubmit={handleSubmit} aria-label="Booking form">
              <label htmlFor="name" className="sr-only">Your Name</label>
              <input id="name" name="name" type="text" placeholder="Your Name" required value={form.name} onChange={handleChange} />

              <label htmlFor="email" className="sr-only">Email Address</label>
              <input id="email" name="email" type="email" placeholder="Email Address" required value={form.email} onChange={handleChange} />

              <label htmlFor="phone" className="sr-only">Phone Number</label>
              <input id="phone" name="phone" type="tel" placeholder="Phone Number" required value={form.phone} onChange={handleChange} />

              <label htmlFor="eventType" className="sr-only">Event Type</label>
              <select id="eventType" name="eventType" required value={form.eventType} onChange={handleChange}>
                <option value="">Select Event Type</option>
                <option value="wedding">Wedding</option>
                <option value="birthday">Birthday</option>
                <option value="post-wedding">Post Wedding</option>
                <option value="other">Other</option>
              </select>

              <label htmlFor="date" className="sr-only">Event Date</label>
              <input id="date" name="date" type="date" required value={form.date} onChange={handleChange} />

              <label htmlFor="message" className="sr-only">Additional Message</label>
              <textarea id="message" name="message" placeholder="Additional Message (Optional)" rows="4" value={form.message} onChange={handleChange} />

              <button type="submit">Send Booking Request</button>
            </form>

            {status && (
              <div className={`form-status ${status.type === 'error' ? 'error' : 'success'}`} role="status">
                {status.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
